import { MIGHTYMEALS_INDEX_IMG } from "../../constants";

const useStyles = theme => ({
    topLogo: {
        [theme.breakpoints.up('sm')]: {
            height: '140px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
    topTitle: {
        fontSize: '2em',
        fontFamily: 'SignPainter-HouseScript',
        fontWeight: 'bold',
        color: '#182C55',
    },
    chapterSlider: {
        fontFamily: '"League Gothic", sans-serif',
        textDecoration: 'underline',
        textUnderlineOffset: '15px',
        fontSize: '1.5em',
        marginTop: '10px',
        color: '#182C55',
    },
    sliderArrow: {
        color: '#EE3124',
        cursor: 'pointer',
    },
    bottomGrid: {
        padding: '1em 5em 1em 5em',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: '1em',
        },
    },
    nameSearch: {
        width: '80%',
        height: '60px',
        padding: '10px',
        border: '1px solid #182C55',
        borderRadius: '4px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '3em',
            width: '50vw',
        },
    },
    pageControl: {
        position: 'absolute',
        right: '5em',
        [theme.breakpoints.up('sm')]: {
            bottom: 0,
        },
        [theme.breakpoints.down('sm')]: {
            right: '1em',
        },
    },
    // Mighty Meals Leaderboard Result
    guestDiv: {
        padding: '1em 5em 1em 5em',
        [theme.breakpoints.down('sm')]: {
            padding: '1em',
        },
    },
    guestIndex: {
        float: 'left',
        width: '10%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '1.2em',
        fontFamily: '"League Gothic", sans-serif',
        backgroundImage: `url(${MIGHTYMEALS_INDEX_IMG})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        color: '#182C55',
    },
    guestName: {
        fontsize: '1.2em',
        fontFamily: '"Barlow", sans-serif',
        marginLeft: '1em',
    },
    guestPoints: {
        fontSize: '1.2em',
        fontWeight: 'bold',
        fontFamily: '"League Gothic", sans-serif',
        float: 'right',
        color: '#182C55',
    },
    activeButton: {
        cursor: 'pointer',
        color: '#EE3124',
    },
    inactiveButton: {
        color: '#D9D9D9',
    },
    currentPage: {
        margin: '6px 6px 3px 6px',
        color: '#EE3124',
        width: '6px',
        height: '6px',
    },
    otherPage: {
        margin: '6px 6px 3px 6px',
        color: '#D9D9D9',
        width: '6px',
        height: '6px',
        cursor: 'pointer',
    }
});

export default useStyles;